export default {
  HOME_PAGE: '/',
  DASHBOARD_PAGE: '/dashboard',
  LOGIN_PAGE: '/user/login',
  SSO_LOGIN_PAGE: '/user/sso_login',
  ONBOARDING_WIZARD: '/onboarding/wizard',
  RESET_PASSWORD_NEW: '/user/password/new',
  RESET_PASSWORD_EDIT: '/user/password/edit',
  ACCEPT_USER_INVITATION: '/user/invitation/accept',
  HOME_PAGE_ITEM: '/item',
  HOME_PAGE_ITEM_COMMENTS: 'item/:itemUuid/comments',
  TEAM_PAGE: '/team',
  TEAM_PAGE_ACTION_ITEMS: '/team/action_items',
  TEAM_PAGE_ACTION_ITEM_DETAILS: '/team/action_items/item/:itemUuid',
  TEAM_PAGE_SURFACE_AI: '/team/feed',
  ASSISTANTS_PAGE: '/assistants',
  SETTINGS_PAGE: '/settings',
  SETTINGS_PROFILE_PAGE: '/settings/profile',
  SETTINGS_NOTIFICATIONS_PAGE: '/settings/notifications',
  SETTINGS_INTEGRATIONS_PAGE: '/settings/integrations',
  SETTINGS_USER_MANAGEMENT_PAGE: '/settings/user_management',
  SETTINGS_BILLING_PAGE: '/settings/billing',
  SETTINGS_ENTERPRISE_PAGE: '/settings/enterprise',
  GOALS_PAGE: '/goals',
  GOALS_NEW_PAGE: '/goals/new',
  GOALS_PAGE_MODAL: '/goals/:slug/modal',
  GOALS_DETAIL_PANEL: '/goals/:slug/detail',
  GOALS_DETAIL_PANEL_ITEM_COMMENTS_URL: '/goals/:slug/detail/item/:itemUuid/comments',
  GOALS_DETAIL_PAGE: '/goals/:slug',
  GOALS_DETAIL_PAGE_ITEM_COMMENTS: '/goals/:slug/item/:itemUuid/comments',
  WORKSPACES: '/workspaces',
  WORKSPACE_PAGE: '/workspaces/:workspaceId?',
  WORKSPACE_START_MEETING: '/workspaces/:workspaceId?/start_meeting',
  WORKSPACE_GOALS_PAGE: '/workspaces/:workspaceId?/goals',
  WORKSPACE_GOALS_DETAILS_PANEL: '/workspaces/:workspaceId?/goals/:slug/detail',
  WORKSPACE_HISTORY_PAGE: '/workspaces/:workspaceId?/history',
  WORKSPACE_HISTORY_MEETING_SUMMARIES: '/workspaces/:workspaceId?/history/meeting_summaries',
  WORKSPACE_HISTORY_PAGE_ITEMS: '/workspaces/:workspaceId?/history/items',
  WORKSPACE_HISTORY_PAGE_ITEMS_ITEM_COMMENTS_PAGE: '/workspaces/:workspaceId?/history/items/item/:itemUuid/comments',
  WORKSPACE_RELATIONSHIP_PAGE: '/workspaces/:workspaceId?/relationship',
  WORKSPACE_FEEDBACK_PAGE: '/workspaces/:workspaceId?/feedback',
  WORKSPACE_FEEDBACK_ITEM_PAGE: '/workspaces/:workspaceId?/feedback/:feedbackUuid?',
  WORKSPACE_FEEDBACK_REQUEST_PAGE: '/workspaces/:workspaceId?/feedback_request/:feedbackRecognitionRequestId?',
  WORKSPACE_RECOGNITION_REQUEST_PAGE_NEW: '/workspaces/:workspaceId?/recognition_request/new',
  WORKSPACE_FEEDBACK_FORM_PAGE: '/workspaces/:workspaceId?/feedback_form/:feedbackRecognitionRequestId?',
  WORKSPACE_EDIT_FEEDBACK_FORM_PAGE: '/workspaces/:workspaceId/feedback_form/:feedbackUuid/edit',
  WORKSPACE_PRIVATE_PAGE: '/workspaces/:workspaceId?/private',
  WORKSPACE_ACTIVITIES_PAGE: '/workspaces/:workspaceId?/activities',
  WORKSPACE_MEETING_MODE: '/workspaces/:workspaceId?/meet',
  WORKSPACE_MEETING_MODE_ITEM: '/workspaces/:workspaceId?/meet/item/:itemUuid/comments',
  WORKSPACE_MEETING_ITEM: '/workspaces/:workspaceId?/item/:itemUuid',
  WORKSPACE_MEETING_ITEM_COMMENTS: '/workspaces/:workspaceId?/item/:itemUuid/comments',
  WORKSPACE_MEETING_ITEM_COMMENTS_COMMENT_UUID: '/workspaces/:workspaceId?/item/:itemUuid/comments/:commentUuid?',
  WORKSPACE_AGENDA_HISTORY: '/workspaces/:workspaceId?/history/agenda',
  WORKSPACE_AGENDA_HISTORY_ITEM_COMMENTS: '/workspaces/:workspaceId?/history/agenda/item/:itemUuid/comments',
  WORKSPACE_SETTINGS: '/workspaces/:workspaceId?/settings',
  ZOOM_LANDING_PAGE: '/zoom-workspaces',
  PLANS_PAGE: '/plans',
  PLANS_BUY_PAGE: '/buy',
  FEEDBACK_NEW: '/feedback/new',
  CURRENT_USER_PROFILE_PAGE: '/profile',
  CURRENT_USER_PROFILE_PAGE_HOME: '/profile/me',
  USER_PROFILE_PAGE: '/profile/:userSlug?',
  RECOMMENDATION_ANALYTICS: '/recommendation_analytics',
  INTEGRATIONS: '/user/integrations',
  ADMIN: '/admin',
  ADMIN_MEMBERS: '/admin/members',
  ADMIN_BILLING: '/admin/billing',
  ADMIN_INTEGRATIONS: '/admin/integrations',
  ADMIN_ANALYTICS: '/admin/analytics',
  ADMIN_REPORTS: '/admin/reports',
  ANALYTICS_ADMIN: '/analytics/admin',
  ANALYTICS_MANAGER_DASHBOARD: '/analytics/dashboard',
  ADMIN_NETWORK: '/admin/social_graph_vis',
  COACHING: '/coaching',
  COACHING_360: '/coaching/reviews',
  COACHING_FEEDBACK: '/coaching/feedback',
  COACHING_KUDOS: '/coaching/kudos',
  COACHING_360_START: '/coaching/reviews/start',
  COACHING_360_NEW: '/coaching/reviews/new',
  COACHING_SELF_360_NEW: '/coaching/reviews/self/new',
  COACHING_360_COMPILATION: '/coaching/reviews/:reviewSlug',
  COACHING_360_SHARE: '/coaching/reviews/:reviewSlug/share',
  PEER_REVIEW_FORM: '/peer-review/:formSlug',
  REVIEW_TEMPLATE_PREVIEW: '/review-template-preview/',
  SURFACEAI_PAGE: '/surface',
  SURFACEAI_INTEGRATIONS_PAGE: '/surface/integrations',
  MEETING_ITEM_COMMENTS_PAGE: '/item/:itemUuid/comments',
  AI_TOOLKIT_PAGE: '/ai-toolkit',
  UPDATE_AI_PAGE: '/ai-toolkit/update-ai',
  UPDATE_AI_SETTING_PAGE: '/ai-toolkit/update-ai/:slug',
  UPDATE_AI_REPORT_PAGE: '/update-ai/r/:slug',
  FEEDBACK_TEMPLATE_BUILD_PAGE: '/coaching/feedback/template/:slug',
  PERFORMANCE_REVIEWS: '/reviews',
  PERFORMANCE_REVIEWS_PAST: '/reviews/past',
  PERFORMANCE_REVIEWS_ADMIN: '/reviews/admin',
  PERFORMANCE_REVIEWS_REVIEW: '/reviews/:reviewSlug',
  PERFORMANCE_REVIEWS_REVIEW_SHARE: '/reviews/:reviewSlug/share',
  PERFORMANCE_REVIEWS_ADMIN_CYCLES_CYCLE: '/reviews/admin/cycles/:reviewCycleSlug',
  PERFORMANCE_REVIEWS_ADMIN_TEMPLATES: '/reviews/admin/templates',
  PERFORMANCE_REVIEWS_TEMPLATE_BUILD_PAGE: '/reviews/admin/template/:slug',
};
